import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/lib/i18n';
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/barlow-condensed/600.css';
import '@fontsource/barlow-condensed/700.css';
// Public site (/, /conditions, /reglement).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/600.css';
import '@fontsource/oswald/700.css';
import '@/index.css';
import { App } from '@/App';
import { initSentry } from '@/lib/sentry';
import { loadAnalytics, stopAnalytics } from '@/lib/analytics';
import { getConsent, subscribeConsent } from '@/lib/consent';

initSentry();

// GA4 is requested only after an explicit "accept"; a refusal or revocation stops it.
function syncAnalytics() {
  if (getConsent() === 'granted') loadAnalytics();
  else stopAnalytics();
}
syncAnalytics();
subscribeConsent(syncAnalytics);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
